import { render, staticRenderFns } from "./taxForm.vue?vue&type=template&id=5e4849ae&scoped=true"
import script from "./taxForm.vue?vue&type=script&lang=js"
export * from "./taxForm.vue?vue&type=script&lang=js"
import style0 from "./taxForm.vue?vue&type=style&index=0&id=5e4849ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4849ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e4849ae')) {
      api.createRecord('5e4849ae', component.options)
    } else {
      api.reload('5e4849ae', component.options)
    }
    module.hot.accept("./taxForm.vue?vue&type=template&id=5e4849ae&scoped=true", function () {
      api.rerender('5e4849ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auditProduct/taxForm.vue"
export default component.exports